/* ============================================================
   Plentum carousel — shared by the ph-* home sections and cc-reviews.
   A native scroll-snap track (swipe, trackpad and arrow keys work with
   no JS) plus optional prev/next buttons and dots that this file wires up.
   Markup:
     [data-pl-carousel]
       [data-pl-track]            the scrolling element
         [data-pl-slide] ...
       [data-pl-nav] hidden       optional; holds the controls below
         [data-pl-prev] [data-pl-dots] [data-pl-next]
   The nav stays hidden until the track really overflows, so a layout that
   fits (a desktop grid) never shows dead controls.
   ============================================================ */
(function () {
  if (window.__plCarousel) return;
  window.__plCarousel = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(root) {
    if (root.__plCar) return;
    var track = root.querySelector('[data-pl-track]');
    if (!track) return;
    root.__plCar = true;

    var nav = root.querySelector('[data-pl-nav]');
    var dotsBox = root.querySelector('[data-pl-dots]');
    var prev = root.querySelector('[data-pl-prev]');
    var next = root.querySelector('[data-pl-next]');
    var label = root.getAttribute('data-pl-label') || 'slide';
    var stops = [];
    var active = -1;
    var pending = null; /* stop we asked for; lets repeat clicks advance during a smooth scroll */

    function slides() {
      return Array.prototype.filter.call(track.children, function (el) { return el.hasAttribute('data-pl-slide'); });
    }

    /* Snap positions: each slide's start, clamped to the max scroll, de-duplicated.
       Measured from rects so it doesn't depend on the offsetParent. */
    function measure() {
      var max = track.scrollWidth - track.clientWidth;
      var list = slides();
      stops = [];
      if (max > 4 && list.length > 1) {
        var origin = list[0].getBoundingClientRect().left;
        list.forEach(function (s) {
          var x = Math.min(Math.max(s.getBoundingClientRect().left - origin, 0), max);
          if (!stops.length || x - stops[stops.length - 1] > 4) stops.push(x);
        });
      }
      if (nav) nav.hidden = stops.length < 2;
      if (dotsBox && dotsBox.children.length !== stops.length) {
        dotsBox.innerHTML = '';
        stops.forEach(function (x, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'pl-car__dot';
          b.setAttribute('aria-label', 'Go to ' + label + ' ' + (i + 1) + ' of ' + stops.length);
          b.addEventListener('click', function () { go(i); });
          dotsBox.appendChild(b);
        });
      }
      active = -1;
      update();
    }

    function update() {
      if (!stops.length) return;
      var pos = track.scrollLeft;
      var best = 0;
      stops.forEach(function (x, i) { if (Math.abs(x - pos) < Math.abs(stops[best] - pos)) best = i; });
      if (best === pending) pending = null;
      if (best === active) return;
      active = best;
      if (dotsBox) {
        Array.prototype.forEach.call(dotsBox.children, function (d, i) {
          if (i === best) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
      }
      if (prev) prev.disabled = best === 0;
      if (next) next.disabled = best === stops.length - 1;
    }

    function go(i) {
      if (!stops.length) return;
      i = Math.max(0, Math.min(stops.length - 1, i));
      pending = i;
      track.scrollTo({ left: stops[i], behavior: reduce ? 'auto' : 'smooth' });
    }
    function from() { return pending === null ? active : pending; }

    if (prev) prev.addEventListener('click', function () { go(from() - 1); });
    if (next) next.addEventListener('click', function () { go(from() + 1); });
    /* a finger, wheel or key takes over from any smooth scroll we started; and once a
       scroll settles (scrollend) whatever we asked for is history either way */
    ['pointerdown', 'wheel', 'touchstart', 'keydown', 'scrollend'].forEach(function (ev) {
      track.addEventListener(ev, function () { pending = null; }, { passive: true });
    });
    /* direct handler: update() is O(stops); rAF would stall in background tabs */
    track.addEventListener('scroll', update, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(track);
    else window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    measure();

    root.__plGoToSlide = function (el) {
      var list = slides();
      var idx = list.indexOf(el);
      if (idx < 0 || !stops.length) return;
      var x = Math.min(el.getBoundingClientRect().left - list[0].getBoundingClientRect().left, track.scrollWidth - track.clientWidth);
      var best = 0;
      stops.forEach(function (s, i) { if (Math.abs(s - x) < Math.abs(stops[best] - x)) best = i; });
      go(best);
    };
  }

  function initAll() {
    document.querySelectorAll('[data-pl-carousel]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  /* theme editor: new section markup, and bring a selected block into view */
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target && e.target.closest && e.target.closest('[data-pl-slide]');
    var root = slide && slide.closest('[data-pl-carousel]');
    if (root && root.__plGoToSlide) root.__plGoToSlide(slide);
  });
})();
